import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AWS from "../../../assets/images/AWS-logo.jpg";
import Azure from "../../../assets/images/Azure-Logo-PNG.png";
import GCP from "../../../assets/images/GCP-Logo.png";
import Tooltip from "@mui/material/Tooltip";
import {
  Typography,
  Button,
  Input,
  CardFooter,
  CardHeader,
  CardBody,
} from "@material-tailwind/react";

function Configure({
  setStep,
  selectedProvider,
  setFormDataAWS,
  formDataAWS,
  scope,
  formDataAzure,
  setFormDataAzure,
  formDataGCP,
  setFormDataGCP,
  uploadedJson,
  setUploadedJson,
}) {
  const navigate = useNavigate();
  const [isNextButtonDisabled, setIsNextButtonDisabled] = useState(true);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormDataAWS({
      ...formDataAWS,
      [name]: value,
    });
  };
  const handleInputChangeAzure = (e) => {
    const { name, value } = e.target;
    setFormDataAzure({
      ...formDataAzure,
      [name]: value,
    });
  };
  const handleInputChangeGCP = (e) => {
    const { name, value } = e.target;
    setFormDataGCP({
      ...formDataGCP,
      [name]: value,
    });
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const content = event.target.result;
        setUploadedJson(JSON.parse(content));
      };
      reader.readAsText(file);
    }
  };
  const areAllFieldsFilled = () => {
    if (selectedProvider === "AWS") {
      const { accID, accname, role, externalId } = formDataAWS;
      return accID && accname && role && externalId;
    } else if (selectedProvider === "Azure") {
      const { tenantID, accname, subID, appID, appClientSecret } =
        formDataAzure;
      return tenantID && accname && subID && appID && appClientSecret;
    } else if (selectedProvider === "GCP") {
      const { prjID, accname } = formDataGCP;
      return prjID && accname;
    }

    return false;
  };

  useEffect(() => {
    setIsNextButtonDisabled(!areAllFieldsFilled());
  }, [formDataAWS, formDataAzure, formDataGCP, selectedProvider]);

  return (
    <>
      <CardHeader
        floated={false}
        shadow={false}
        className=" bg-transparent rounded-none"
      >
        <div className="flex flex-col justify-center items-center mb-3.5 gap-4">
          <img
            src={
              selectedProvider === "AWS"
                ? AWS
                : selectedProvider === "Azure"
                ? Azure
                : selectedProvider === "GCP"
                ? GCP
                : ""
            }
            alt="Logo"
            className="w-20 h-auto rounded-md"
          />
          <Typography variant="h5" color="blue-gray">
            Configure Account
          </Typography>
        </div>
      </CardHeader>

      <CardBody>
        {selectedProvider === "AWS" ? (
          <>
            <div className="mb-4">
              <div className="mb-2.5">
                <Typography variant="h5" color="blue-gray">
                  {scope} Details
                </Typography>
                <Typography variant="h6" color="blue-gray">
                  Add the necessary details for Prisma Cloud to apply
                  permissions for capabilities and create a stack.
                </Typography>
              </div>
              <div className="grid grid-cols-2 gap-4 mb-4">
                <Input
                  type="text"
                  label="Account ID"
                  name="accID"
                  size="lg"
                  value={formDataAWS.accID}
                  className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  onChange={handleInputChange}
                />
                <Input
                  type="text"
                  className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  name="accname"
                  label="Account Name"
                  size="lg"
                  value={formDataAWS.accname}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="mb-4">
              <Typography variant="h6" color="blue-gray">
                Apply Permissions for Cloud
              </Typography>
              <div className="flex gap-4">
                <Button size="md" variant="gradient">
                  Create IAM Role
                </Button>
                <Button variant="gradient" size="md">
                  Download IAM Role CFT
                </Button>
              </div>
            </div>
            <div className="flex flex-row gap-4">
              <Input
                type="text"
                className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                name="role"
                label="IAM Role ARN"
                value={formDataAWS.role}
                onChange={handleInputChange}
              />

              <Input
                type="text"
                className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                name="externalId"
                label="External Id"
                value={formDataAWS.externalId}
                onChange={handleInputChange}
              />
            </div>
          </>
        ) : selectedProvider === "Azure" ? (
          <>
            <div>
              <Typography variant="h5" color="blue-gray" className="mb-2">
                {scope} Details
              </Typography>

              <div className="grid grid-cols-2 gap-4 mb-4">
                <Input
                  type="text"
                  className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  size="lg"
                  name="tenantID"
                  label="Tenant ID"
                  value={formDataAzure.tenantID}
                  onChange={handleInputChangeAzure}
                />
                <Input
                  type="text"
                  className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  name="accname"
                  size="lg"
                  label="Account Name"
                  value={formDataAzure.accname}
                  onChange={handleInputChangeAzure}
                />
              </div>
              <Input
                type="text"
                className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                name="subID"
                size="lg"
                label="Subscription ID"
                value={formDataAzure.subID}
                onChange={handleInputChangeAzure}
              />
              <div className="my-4">
                <Button variant="gradient" size="md">
                  Download IAM Role CFT
                </Button>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <Input
                  type="text"
                  className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  name="appID"
                  label="Application ID"
                  value={formDataAzure.appID}
                  onChange={handleInputChangeAzure}
                />
                <Input
                  type="text"
                  className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  name="appClientSecret"
                  label="Application Client Secret"
                  value={formDataAzure.appClientSecret}
                  onChange={handleInputChangeAzure}
                />
              </div>
            </div>
          </>
        ) : selectedProvider === "GCP" ? (
          <>
            <div className="mb-4">
              <Typography variant="h5" color="blue-gray">
                Details
              </Typography>

              <div className="grid grid-cols-2 gap-4">
                <Input
                  type="text"
                  className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  name="prjID"
                  label="Project ID"
                  size="lg"
                  value={formDataGCP.prjID}
                  onChange={handleInputChangeGCP}
                />
                <Input
                  type="text"
                  className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  name="accname"
                  size="lg"
                  label="Account Name"
                  value={formDataGCP.accname}
                  onChange={handleInputChangeGCP}
                />
              </div>
            </div>
            <div className="mb-4">
              <Typography variant="h6" color="blue-gray">
                Download the terraform and complete the steps to configure
                account
              </Typography>
              <Button variant="gradient" size="md">
                Download Terraform script
              </Button>
            </div>
            <div>
              <Typography variant="h6" color="blue-gray">
                Upload your JSON file here
              </Typography>
              <input
                type="file"
                accept=".json"
                onChange={handleFileUpload}
                className="block w-full p-2.5 border border-gray-200 shadow-sm rounded-lg text-sm focus:z-10 focus:border-blue-gray-500 focus:ring-blue-gray-500 file:bg-gray-50 file:border-0 cursor-pointer"
              />
              {uploadedJson && (
                <div className="mt-5">
                  <Typography
                    variant="h6"
                    color="blue-gray"
                    className="flex justify-center items-center mb-5"
                  >
                    Contents of Uploaded JSON:
                  </Typography>
                  <ul className="pl-5 list-disc">
                    {Object.keys(uploadedJson).map((key, index) => (
                      <li key={index} className="mb-2.5">
                        <strong>{key}:</strong> {uploadedJson[key]}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            <div className="flex justify-center items-center h-screen">
              <Typography variant="h2" color="blue-gray">
                Please go back and fill the form...
              </Typography>
            </div>
          </>
        )}
      </CardBody>

      <CardFooter>
        <div className="mt-auto flex justify-end gap-4">
          <Button
            variant="gradient"
            color="light-blue"
            onClick={() => {
              setStep("Get Started");
            }}
          >
            Previous
          </Button>
          <Tooltip
            title={isNextButtonDisabled ? "Please fill in all details" : ""}
          >
            <span>
              <Button
                variant="gradient"
                color="light-blue"
                onClick={() => {
                  setStep("Review");
                }}
                disabled={isNextButtonDisabled}
              >
                Next
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="text"
            color="red"
            onClick={() => {
              navigate("/inventory/assets");
            }}
          >
            Cancel
          </Button>
        </div>
      </CardFooter>
    </>
  );
}

export default Configure;
